import { lazy, Suspense } from "react";
import type { GroupedToolCall } from "../group-tool-messages";
import { PendingReviewPlacement } from "../PendingToolReviewScope";
import type { ChatToolMessage } from "../types";
import { ToolCallBlock } from "./ToolCallBlock";

const OrdinaryToolRow = lazy(() =>
  import("./OrdinaryToolRow").then((module) => ({
    default: module.OrdinaryToolRow,
  }))
);
const interactiveTools = new Set([
  "edit_data_key",
  "write_data_key",
  "draft_skill",
  "draft_training_program",
  "draft_training_quiz",
  "task",
]);

export const CompactToolRow = ({
  call,
  result,
  running,
  reviewKey,
  decision,
}: {
  call: GroupedToolCall;
  result?: ChatToolMessage;
  running: boolean;
  reviewKey?: string;
  decision?: "approve" | "reject" | "edit";
}) => {
  if (reviewKey) {
    return (
      <div data-tool-call-id={call.id} className="min-w-0">
        <PendingReviewPlacement reviewKey={reviewKey} />
      </div>
    );
  }
  if (interactiveTools.has(call.toolCall.name ?? "")) {
    return (
      <div data-tool-call-id={call.id} className="min-w-0">
        <ToolCallBlock
          decision={decision}
          toolCall={call.toolCall}
          toolResult={result}
          isLoading={running && !result}
        />
      </div>
    );
  }
  return (
    <Suspense
      fallback={
        <div className="min-h-[30px] text-[13px] text-[#6b7280]">
          Loading tool…
        </div>
      }
    >
      <OrdinaryToolRow
        call={call}
        result={result}
        running={running}
        decision={decision}
      />
    </Suspense>
  );
};
